import React from "react";
import { toast } from "react-toastify";
import { APIURL } from "../redux/action/config";

const DownloadDropdown = ({
  moduleName = "users",
  label = "Download File",
  filters = {},
  fileName = "export",
}) => {
  const handleDownload = async (format = "csv") => {
    try {
      // Construct query parameters from filters
      const params = new URLSearchParams();
      Object.keys(filters).forEach((key) => {
        if (filters[key]) {
          params.append(key, filters[key]);
        }
      });

      const queryString = params.toString();
      const endpoint = `${APIURL}/api/v1/${moduleName}/download/${format}`;
      const url = queryString ? `${endpoint}?${queryString}` : endpoint;

      toast.info(`Downloading ${format.toUpperCase()}...`);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `${fileName}.${format}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      toast.success(`${format.toUpperCase()} downloaded successfully`);
    } catch (error) {
      console.error("Download failed", error);
      toast.error(`Failed to download ${format.toUpperCase()}`);
    }
  };

  return (
    <div className="ms-3">
      <button
        type="button"
        className="btn pgf btn-secondary dropdown-toggle"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        style={{ background: "none" }}
      >
        {label}
      </button>

      <ul className="dropdown-menu">
        <li>
          <button
            type="button"
            className="dropdown-item"
            onClick={() => handleDownload("csv")}
            style={{ cursor: "pointer" }}
          >
            Download as CSV
          </button>
        </li>
        <li>
          <button
            type="button"
            className="dropdown-item"
            onClick={() => handleDownload("pdf")}
            style={{ cursor: "pointer" }}
          >
            Download as PDF
          </button>
        </li>
      </ul>
    </div>
  );
};

export default DownloadDropdown;
